import request from "@/utils/request";

/**
 * 获取下级投注明细接口
 *
 * @description 获取下级投注明细接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryAgentBettingList(playload) {
  return request({
    url: "/api/v2/agent/queryAgentBettingList",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true
  });
}
/**
 * 查询下级交易明细接口
 *
 * @description 查询下级交易明细接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryAgentBalanceDetailList(playload, config) {
  return request({
    url: "/api/v2/agent/queryAgentBalanceDetailList",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true,
    ...config
  });
}
/**
 * 代理中心—代理佣金—查询用户代理佣金列表
 *
 * @description 代理中心—代理佣金—查询用户代理佣金列表
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function querySubuserRebate(playload) {
  return request({
    url: "/api/v2/agent/subuser/rebate",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true
  });
}

export async function queryincome(playload) {
  return request({
    url: "/api/v2/agent/subuser/income",
    method: "POST",
    data: playload,
    userId: true,
    loading: true,
    noEncrypt: true
  });
}
/**
 * 代理中心—代理报表—查询用户个人报表（H5、客户端使用）
 *
 * @description 代理中心—代理报表—查询用户个人报表（H5、客户端使用）
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function querySubuserOneReport(playload, config) {
  return request({
    url: "/api/v2/agent/subuser/oneReport",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true,
    ...config
  });
}
/**
 * 代理中心—代理报表—查询用户团队报表（H5、客户端使用）
 *
 * @description 代理中心—代理报表—查询用户团队报表（H5、客户端使用）
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryTeamReport(playload, config) {
  return request({
    url: "/api/v2/agent/queryTeamReport",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true,
    ...config
  });
}
/**
 * 代理中心—下级开户—新增下级代理（会员）
 *
 * @description 代理中心—下级开户—新增下级代理（会员）
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function addSubuser(playload, config) {
  return request({
    url: "/api/v2/agent/addSubuser",
    method: "POST",
    data: playload,
    userId: true,
    ...config
  });
}
/**
 * 代理中心—下级开户—修改下级代理（会员）
 *
 * @description 代理中心—下级开户—修改下级代理（会员）
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function updateSubuser(playload, config) {
  return request({
    url: "/api/v2/agent/updateSubuser",
    method: "POST",
    data: playload,
    userId: true,
    ...config
  });
}
/**
 * 代理中心—用户管理—查询用户下级代理（会员）列表
 *
 * @description 代理中心—用户管理—查询用户下级代理（会员）列表
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function querySubuser(playload) {
  return request({
    url: "/api/v2/agent/subuser/list",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true
  });
}

/**
 * 查询下级报表
 * @param playload
 * @return {Promise<void>}
 */
export async function queryListTeamSubUsers(playload) {
  return request({
    url: "/api/v2/agent/listTeamSubusers",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true
  });
}
